import React from "react";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
    handle: {
        display: "inline-flex",
        fontSize: 12,
        lineHeight: 1,
        color: theme.palette.emteria.text.secondary,
        cursor: "grab",
        opacity: 0,
        "tbody tr:hover &, th:hover &": { opacity: 1 },
        "@media (hover: none)": { opacity: 1 },
    },
}));

type Props = {
    /**
     * What dropping the item does, shown on hover.
     */
    title: string;
    /**
     * Places the handle inside its cell; the look stays the same everywhere.
     */
    className?: string;
    onPointerEnter?: () => void;
};

/**
 * The grip a table row or header cell is dragged by. It shows while its row (or header cell) is hovered, and a click
 * on it never reaches the row, so grabbing it does not also open the row's details.
 */
export const DragHandle = React.forwardRef<HTMLSpanElement, Props>(({ title, className, onPointerEnter }, ref) => {
    const { classes, cx } = useStyles();

    return (
        <span
            ref={ref}
            className={cx(classes.handle, className)}
            title={title}
            onPointerEnter={onPointerEnter}
            onClick={(event) => event.stopPropagation()}
        >
            {/* eslint-disable-next-line no-restricted-syntax -- the one place the drag-handle icon is rendered */}
            <i className="fa-solid fa-grip-vertical" />
        </span>
    );
});
